import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Flex, message, Col, Row } from "antd";
import { CustomInput, CustomButton, CustomTitle } from "../../components";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";
import { GetSingleCourierById, LinkAccount } from "../../api's/onboarding";

const TransportConnectionModal = ({ data, onSuccess }) => {

  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const navigate = useNavigate();
  const [courierModal, setCourierModal] = useState(["Client ID"]);


  useEffect(() => {
    if (data?.required_inputs && Array.isArray(data?.required_inputs)) {
      setCourierModal(data?.required_inputs);
    }
  }, [data]);

  // useEffect(() => {
  //   if (courierModal && (data?.status === "linked" || data?.status === "error")) {
  //     if(data?.id || data?.courier_id){
  //       let id=data?.id || data?.courier_id
  //       GetSingleCourier(id);
  //     }
  //   }
  // }, [courierModal, data]);

  useEffect(() => {
    if (data) {
      if (data.credentials && typeof data.credentials === "object") {
        // EDIT MODE
        const keys = Object.keys(data.credentials);
        setCourierModal(keys);
        form.setFieldsValue(data.credentials); // pre-fill
      } else if (Array.isArray(data.required_inputs)) {
        // ADD MODE
        setCourierModal(data.required_inputs);
      }
    }
  }, [data, form]);
  

  const GetSingleCourier = (id) => {
    showSpin();
    GetSingleCourierById(token, id)
      .then((res) => {
        console.log('res :" ' , res)
        const responseData = res?.data?.data;
        if (responseData?.is_success) {
          form.setFieldsValue(responseData?.data?.couriers?.credentials);
        } else {
          message.error(responseData?.message);
        }
      })
      .catch(unauthorize)
      .finally(hideSpin);
  };

  const unauthorize = (error) => {
    if (error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const sendFormData = (model) => {
  
    // showSpin();
    //setIsFormValid(true);
    onSuccess(model);
    
    
    // LinkAccount(token, model)
    // .then((res) => {
    //   const responseData = res?.data?.data;
    //   if (responseData?.is_success) {
    //       onSuccess(responseData?.data);
    //       // closeModal();
    //       // message.success(responseData?.message);
    //     } else {
    //       message.error(responseData?.message);
    //     }
    //   })
    //   .catch(unauthorize)
    //   .finally(() => {
    //     hideSpin();
    //     setIsFormValid(false);
    //   });
  };

  const onFinishForm = (values) => {
    //let id=data.id;
  if (values && Object.keys(values).length > 0) {
    let model = {
     // courier_id: id,
      credentials: { ...values },
      //client_id: id,
      //client_secret:id,
    };
    model.value = "new"
    sendFormData(model);

  }
};
  const handleCancel = () => {

    const obj = courierModal.reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {});
    
  
    let model = { credentials: obj };
    model.value = "basic"
    sendFormData(model);
  };


  return (
    <>
      <CustomTitle text="Instructions" fontSize="14px" fontWeight="600" color="black" />
      <p style={{fontSize:"14px"}} dangerouslySetInnerHTML={{ __html: data?.instructions }}></p>

      <Form
        form={form}
        name="validateOnly"
        layout="vertical"
       // initialValues={{ client_id: "", client_secret: "" }}
        autoComplete="off"
        onFinish={onFinishForm}
      >
        <Row gutter={12}>
          <Col span={12}>
            {courierModal.map((element) => (
            <Form.Item
            key={element}
            className="custom-input form-input-style"
            label={element}
            name={element}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            style={{ fontSize: "14px", fontWeight: 600,marginTop:"10px" }} 
            rules={[{ required: true, message: `Please input ${element}` }]}>
          
                <CustomInput
                  placeholder={`Paste ${element} here`}
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            ))}
          </Col>
        </Row>

        <Flex gap="16px" justify="end" style={{ marginTop: "32px" }}>
          <CustomButton
            text="I'm okay with basic tracking"
            bgColor="#F3F3F3"
            color="black"
            fontSize="14px"
            fontWeight="600"
            boxShadow="none"
            height="40px"
            onClick={handleCancel}
          />
          <CustomButton
            text="Confirm"
            bgColor="black"
            color="white"
            height="40px"
            width="80px"
            fontSize="14px"
            fontWeight="600"
            boxShadow="none"
            borderRadius="8px"
            isFormValid={isFormValid}
            htmlType="submit"
          />
        </Flex>
      </Form>
    </>
  );
};

export default TransportConnectionModal;
